const assignedUserStatus = {
  PENDING: "PENDING", // assigned to user but user has not accepted
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED"
};

export default assignedUserStatus;